import { render, staticRenderFns } from "./Directories.vue?vue&type=template&id=4c3dfa1c&scoped=true&"
import script from "./Directories.vue?vue&type=script&lang=js&"
export * from "./Directories.vue?vue&type=script&lang=js&"
import style0 from "./Directories.vue?vue&type=style&index=0&id=4c3dfa1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3dfa1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c3dfa1c')) {
      api.createRecord('4c3dfa1c', component.options)
    } else {
      api.reload('4c3dfa1c', component.options)
    }
    module.hot.accept("./Directories.vue?vue&type=template&id=4c3dfa1c&scoped=true&", function () {
      api.rerender('4c3dfa1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/dashboards/Directories.vue"
export default component.exports